import { ReportsPdfTableHeader } from '../ReportsPdfTableHeader'
import { ReportsPdfTableRow } from '../ReportsPdfTableRow'

export const ReportsPdfTableHeaderRow = () => {
  return (
    <ReportsPdfTableRow fixed={true}>
      <ReportsPdfTableHeader />
    </ReportsPdfTableRow>
  )
}
